module.exports = __webpack_public_path__ + "img/1_005.f05fb275.jpg";